var App = App || {};

App.Alerts = (() => {
    const init = () => {
        let alerts = document.querySelectorAll('.site-alert');

        alerts.forEach((alert) => {
            alert.querySelector('.site-alert__close').addEventListener('click', (e) => {
                e.preventDefault();
                dismiss(alert);
            });
        });
    }

    const dismiss = alert => {
        alert.classList.add('site-alert--dismissed');
        alert.addEventListener('transitionend', () => {
            afterDismissed(alert);
        });
        App.Cookies.setItem('AlertDismissed-' + alert.dataset.alertid, 'true', Infinity, '/', window.location.hostname, window.location.protocol === 'https:');
    }

    const afterDismissed = alert => {
        alert.remove();
    }

    return {
        init: init
    };
})();